import React, { useEffect, useState } from 'react';
import styles from '../Event/eventOptions.module.scss';
import share from '../../assets/images/arrow-square-out.svg';
import reminder from '../../assets/images/calendar-x.svg';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// import trash from '../../assets/images/trash.svg';

export default function EventOptions(props) {
    const isClicked = props.isClicked;
    const { t } = useTranslation();
    const click = (currentEvent) => {
        var options = {
            message: t('ComeAndWatch') + ' ' + currentEvent.title,
            subject: t('ComeAndWatch') + ' ' + currentEvent.title, //email
            files: ['', ''], // an array of filenames either locally or remotely
            // url: 'https://bajenidag.app/events/' + currentEvent.slug
            url: 'https://redirect.fantdemo.com/redirect/bajenidag/events/' + currentEvent.slug
            //chooserTitle: 'Pick an app for share' // Android only, you can override the default share sheet title
        };
        window.plugins.socialsharing.shareWithOptions(options);
    };

    const [isReminderVisible, setIsReminderVisible] = useState(false);

    useEffect(() => {
        var endTime = new Date(props.event.end_date);
        var now = new Date();
        if (endTime > now) {
            setIsReminderVisible(true);
        } else {
            setIsReminderVisible(false);
        }
    }, []);

    const setReminderInCalendar = (currentEvent) => {
        var title = currentEvent.title;
        var eventLocation = '';
        var notes = '';
        var startDate = new Date(currentEvent.start_date);
        var endDate = new Date(currentEvent.end_date);
        // window.plugins.calendar.createEvent(title, eventLocation, notes, startDate, endDate);

        window.plugins.calendar.createCalendar('Calendar');
        var calOptions = window.plugins.calendar.getCalendarOptions(); // grab the defaults
        calOptions.firstReminderMinutes = 15; // default is 60
        calOptions.secondReminderMinutes = 0;
        calOptions.url =
            'https://redirect.fantdemo.com/redirect/bajenidag/events/' + currentEvent.slug;
        window.plugins.calendar.createEventWithOptions(
            title,
            eventLocation,
            notes,
            startDate,
            endDate,
            calOptions
        );
    };

    const checkPermissions = (currentEvent) => {
        if (window.device.platform === 'Android') {
            const { permissions } = window.cordova.plugins;

            var list = [permissions.READ_CALENDAR, permissions.WRITE_CALENDAR];

            permissions.hasPermission(
                list,
                function (status) {
                    if (status.hasPermission) {
                        setReminderInCalendar(currentEvent);
                    } else {
                        permissions.requestPermissions(
                            list,
                            function (status) {
                                if (status.hasPermission) {
                                    setReminderInCalendar(currentEvent);
                                }
                            },
                            function (error) {
                                console.error(error);
                            }
                        );
                    }
                },
                function (error) {
                    console.error(error);
                }
            );
        } else {
            setReminderInCalendar(currentEvent);
        }
    };

    return (
        <>
            {isClicked && (
                <div onClick={() => props.setIsClicked(false)} className={styles.wrapperOverlay}>
                    <div className={styles.eventOptions}>
                        <button
                            className={styles.eventOptionItem}
                            onClick={() => click(props.event)}>
                            <img src={share} alt="Share" />
                            <span>{t('Share')}</span>
                        </button>
                        {isReminderVisible && (
                            <button
                                className={styles.eventOptionItem}
                                onClick={() => checkPermissions(props.event)}>
                                <img src={reminder} alt="Reminder" />
                                <span>{t('CreateReminder')}</span>
                            </button>
                        )}
                        {props.isAdmin && (
                            <Link to={`/events/${props.event.id}/modify`}>
                                <button className={styles.eventOptionItem}>
                                    <svg
                                        width="29"
                                        height="28"
                                        viewBox="0 0 29 28"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M14 19.25C16.8995 19.25 19.25 16.8995 19.25 14C19.25 11.1005 16.8995 8.75 14 8.75C11.1005 8.75 8.75 11.1005 8.75 14C8.75 16.8995 11.1005 19.25 14 19.25Z"
                                            stroke={'black'}
                                        />
                                        <path
                                            d="M13.4391 4.82935L11.3752 3.28193C11.2645 3.19863 11.1356 3.14284 10.999 3.11915C10.8625 3.09546 10.7223 3.10456 10.59 3.14569C9.95078 3.34585 9.33064 3.60243 8.73688 3.91239C8.61397 3.97686 8.50815 4.06964 8.42816 4.18307C8.34817 4.2965 8.2963 4.42732 8.27683 4.56474L7.91199 7.11874C7.77292 7.24202 7.63677 7.37023 7.50354 7.50339C7.37035 7.63658 7.2421 7.77277 7.1188 7.91195L7.11874 7.91199L4.5652 8.27716C4.42799 8.29656 4.29736 8.34828 4.18408 8.42807C4.07079 8.50786 3.97808 8.61343 3.9136 8.73608C3.60316 9.3296 3.34608 9.94952 3.14541 10.5886C3.10408 10.7211 3.09486 10.8615 3.11851 10.9983C3.14215 11.135 3.19798 11.2642 3.28139 11.3751L4.82935 13.4391C4.81818 13.6246 4.81257 13.8115 4.81252 13.9999C4.81252 14.1882 4.81813 14.3752 4.82936 14.5608L4.82935 14.5609L3.28193 16.6247C3.19863 16.7355 3.14284 16.8644 3.11915 17.0009C3.09546 17.1375 3.10456 17.2777 3.14569 17.41C3.34585 18.0492 3.60243 18.6693 3.91239 19.2631C3.97686 19.386 4.06964 19.4918 4.18307 19.5718C4.2965 19.6518 4.42732 19.7037 4.56474 19.7231L7.11874 20.088C7.24201 20.227 7.37023 20.3632 7.50338 20.4964C7.63657 20.6296 7.77276 20.7579 7.91194 20.8812L7.91199 20.8812L8.27715 23.4348C8.29655 23.572 8.34828 23.7026 8.42807 23.8159C8.50786 23.9292 8.61343 24.0219 8.73608 24.0864C9.32959 24.3968 9.94952 24.6539 10.5885 24.8546C10.7211 24.8959 10.8615 24.9051 10.9982 24.8815C11.135 24.8578 11.2642 24.802 11.3751 24.7186L13.4391 23.1706C13.6246 23.1818 13.8115 23.1874 13.9999 23.1874C14.1882 23.1874 14.3752 23.1818 14.5608 23.1706L14.5609 23.1706L16.6247 24.718C16.7355 24.8013 16.8644 24.8571 17.0009 24.8808C17.1375 24.9045 17.2777 24.8954 17.41 24.8543C18.0492 24.6541 18.6693 24.3975 19.2631 24.0876C19.386 24.0231 19.4918 23.9303 19.5718 23.8169C19.6518 23.7035 19.7037 23.5726 19.7231 23.4352L20.088 20.8812C20.227 20.758 20.3632 20.6297 20.4964 20.4966C20.6296 20.3634 20.7579 20.2272 20.8812 20.088L20.8812 20.088L23.4348 19.7228C23.572 19.7034 23.7026 19.6517 23.8159 19.5719C23.9292 19.4921 24.0219 19.3865 24.0864 19.2639C24.3968 18.6704 24.6539 18.0504 24.8546 17.4114C24.8959 17.2789 24.9051 17.1385 24.8815 17.0017C24.8578 16.8649 24.802 16.7358 24.7186 16.6248L23.1706 14.5609C23.1818 14.3754 23.1874 14.1885 23.1874 14.0001C23.1874 13.8117 23.1818 13.6247 23.1706 13.4391L23.1706 13.4391L24.718 11.3752C24.8013 11.2645 24.8571 11.1356 24.8808 10.999C24.9045 10.8625 24.8954 10.7223 24.8543 10.59C24.6541 9.95078 24.3975 9.33064 24.0876 8.73688C24.0231 8.61397 23.9303 8.50815 23.8169 8.42816C23.7035 8.34817 23.5726 8.2963 23.4352 8.27683L20.8812 7.91199C20.758 7.77292 20.6297 7.63677 20.4966 7.50354C20.3634 7.37035 20.2272 7.2421 20.088 7.1188L20.088 7.11874L19.7228 4.5652C19.7034 4.42799 19.6517 4.29736 19.5719 4.18408C19.4921 4.07079 19.3865 3.97808 19.2639 3.9136C18.6704 3.60316 18.0504 3.34608 17.4114 3.14541C17.2789 3.10408 17.1385 3.09486 17.0017 3.11851C16.8649 3.14215 16.7358 3.19798 16.6248 3.28139L14.5609 4.82935C14.3754 4.81818 14.1885 4.81257 14.0001 4.81252C13.8117 4.81252 13.6247 4.81813 13.4391 4.82936L13.4391 4.82935Z"
                                            stroke={'black'}
                                        />
                                    </svg>
                                    <span>{t('ChangeEvent')}</span>
                                </button>
                            </Link>
                        )}
                        {/* <button className={styles.eventOptionItem}>
                            <img src={trash} alt="Trash" />
                            <span>Ta Bort</span>
                        </button> */}
                    </div>
                </div>
            )}
        </>
    );
}
